import { useSelector } from 'react-redux';
import { selectIsNewCashierQDFlow } from '~/components/brand/ducks/selectors';

import ExecuteResponseHandler from './quick-deposit-execute';
import ExecuteResponseHandlerBeta from './execute-handler';

const ExecuteHandler = props => {
	const isNewCashierQD = useSelector(selectIsNewCashierQDFlow);

	if (isNewCashierQD && props.result) {
		return <ExecuteResponseHandlerBeta {...props} />;
	}

	return <ExecuteResponseHandler {...props} />;
};

export default ExecuteHandler;
